import { useState } from "react";

const CRMBenefits = () => {
  const [activeTab, setActiveTab] = useState("ben-one");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div>
      <div className="row fiu-benefits-row crm-ben-row">
        <div className="col-lg-6">
          <ul className="fiu-benefits-lists">
            <li
              className={`${activeTab === "ben-one" ? "active" : ""}`}
              onClick={() => handleTabClick("ben-one")}
            >
              <div className="ben-content-flex">
                Enhanced Customer Insights
                <span
                  className={`ben-arr ${activeTab === "ben-one" ? "show" : ""}`}
                >
                  <i className="fa-solid fa-angle-right"></i>
                </span>
              </div>
            </li>
            <li
              className={`${activeTab === "ben-two" ? "active" : ""}`}
              onClick={() => handleTabClick("ben-two")}
            >
              <div className="ben-content-flex">
                Improved Efficiency
                <span
                  className={`ben-arr ${activeTab === "ben-two" ? "show" : ""}`}
                >
                  <i className="fa-solid fa-angle-right"></i>
                </span>
              </div>
            </li>
            <li
              className={`${activeTab === "ben-three" ? "active" : ""}`}
              onClick={() => handleTabClick("ben-three")}
            >
              <div className="ben-content-flex">
                Scalability
                <span
                  className={`ben-arr ${
                    activeTab === "ben-three" ? "show" : ""
                  }`}
                >
                  <i className="fa-solid fa-angle-right"></i>
                </span>
              </div>
            </li>
          </ul>
        </div>
        <div className="col-lg-6">
          <div className="fiu-benefits-right">
            <img
              src={require(`../../../image/custom-software/crm-benefit-img-one.webp`)}
              alt="Custom Software Development Company"
              className={`ben-img ${
                activeTab === "ben-one" ? "show" : ""
              } crm-ben-img`}
            />
            <p
              className={`fiu-benefits-right-content ${
                activeTab === "ben-one" ? "show" : ""
              }`}
            >
              Gain a deeper understanding of customer behavior through advanced
              analytics.
            </p>
            <img
              src={require(`../../../image/custom-software/crm-benefit-img-two.webp`)}
              alt="Custom Software Development Company"
              className={`ben-img ${
                activeTab === "ben-two" ? "show" : ""
              } crm-ben-img`}
            />
            <p
              className={`fiu-benefits-right-content ${
                activeTab === "ben-two" ? "show" : ""
              }`}
            >
              Automate repetitive tasks and focus on building meaningful
              customer relationships.
            </p>
            <img
              src={require(`../../../image/custom-software/crm-benefit-img-three.webp`)}
              alt="Custom Software Development Company"
              className={`ben-img ${
                activeTab === "ben-three" ? "show" : ""
              } crm-ben-img`}
            />
            <p
              className={`fiu-benefits-right-content ${
                activeTab === "ben-three" ? "show" : ""
              }`}
            >
              Build a CRM system that grows with your business.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CRMBenefits;
